<template>
    <div class="main-container">
        <h1>Finished Payments</h1>
        <div class="filters">

            <choose-date v-model="startDate" style="width: 100%" label="Start date" />
            <choose-date v-model="endDate" style="width: 100%" label="End date" />
            <v-btn color="primary" style="width: 20%" @click="getData">Search</v-btn>
        </div>

        <v-data-table :url="url" :headers="headers" :items="data" :pagination.sync="pagination" :total-items="totalItems"
        :rows-per-page-items="[5, 10, 15, 25, 100]"
            :loading="loading">
            <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.id }}</td>
                <td class="text-xs-center">{{ props.item.captain_name }}</td>
                <td class="text-xs-center">{{ props.item.captain_username }}</td>
                <td class="text-xs-center">{{ props.item.entity_type }}</td>
                <td class="text-xs-center">{{ props.item.entity_id }}</td>
                <td class="text-xs-center">{{ props.item.meter_price }}</td>
                <td class="text-xs-center">{{ props.item.fee }}</td>
                <td class="text-xs-center">{{ props.item.to_pay }}</td>
                <td class="text-xs-center">{{ props.item.paid_money }}</td>
                <td class="text-xs-center">{{ props.item.payment_type }}</td>
                <td class="text-xs-center">{{ props.item.required_to_pay }}</td>
                <td class="text-xs-center">{{ props.item.payment_date }}</td>

            </template>
        </v-data-table>

        <!-- :is_expanded="dialog_type === 'Rides'" -->
        <!-- :actions-extra-main="actionsExtraMain" -->
    </div>
</template>
  
<script>
import DataTable from "@/components/wasilni/DataTable";
import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";
import ChoosePassengerMulti from "@/components/wasilni/input/ChoosePassengerMulti";
import ChooseDate from "@/components/wasilni/input/ChooseDate";

export default {
    name: "NewAccounting",
     title: "New Accounting",
    components: {
        DataTable,
        ChooseCaptainsMulti,
        ChoosePassengerMulti,
        ChooseDate,
    },
    data() {
        return {
            url: "complaint",
            captains: [],
            passengers: [],
            totalItems: 0,
            startDate: null,
            endDate: null,
            loading:false,
            data: [],

            headers: [
                { text: '#', value: 'id', align: 'center' },
                { text: 'Name', value: 'captain_name', align: 'center' },
                { text: 'Username', value: 'captain_username', align: 'center' },
                { text: 'Entity Type', value: 'entity_type', align: 'center' },
                { text: 'Entity Id', value: 'entity_id', align: 'center' },
                { text: 'Meter price', value: 'meter_price', align: 'center' },
                { text: 'Fee', value: 'fee', align: 'center' },
                { text: 'To pay', value: 'to_pay', align: 'center' },
                { text: 'Paid money', value: 'paid_money', align: 'center' },
                { text: 'Payment type', value: 'payment_type', align: 'center' },
                { text: 'Required to pay', value: 'required_to_pay', align: 'center' },
                { text: 'Payment date', value: 'payment_date', align: 'center' }
            ],
            pagination: {
                sortBy: "id",
                rowsPerPage: 10,
            },
        };
    },
    mounted() {
        this.getData();
    },
    computed: {
        params() {
            const params = new URLSearchParams();
            if (this.startDate) params.append("from", this.startDate);
            if (this.endDate) params.append("to", this.endDate);
            params.append("perPage", String(this.pagination.rowsPerPage));
            params.append("page", this.pagination.page);
            return params;
        },

    },
    methods: {
        getData() {
            this.loading = true;
            this.axios
                .get(`account/get_finished_accounting_data`, {
                    params: this.params,
                })
                .then((res) => {
                    this.data = Array.isArray(res.data.data.data) ? res.data.data.data : Object.values(res.data.data.data);
                    this.data.forEach(element => {
                        let tmp=element.entity_type.split("\\");
                        element.entity_type=tmp[tmp.length-1];
                    });
                    this.totalItems = res.data.data.total;

                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err.message);
                    this.loading = false;
                });
        },

    },
    watch: {
        pagination: {
            handler() {
                this.getData();
            },
            deep: true,
        },
        // params: {
        //     handler() {
        //         this.getData();
        //     },
        //     deep: true,
        // },
    },
};
</script>
  
<style lang="scss" scoped>
.main-container {
    float: left;
    width: 100%;
    height: auto;
    padding: 18px;
    background: #fff;

    .filters {
        width: 100%;
        float: left;
        display: flex;
        justify-content: flex-start;
        gap: 12px;
    }

    h1 {
        width: 100%;
        float: left;
        height: auto;
        text-align: left;
        font-size: 14pt;
        color: #202731;
        font-weight: 500;
    }

    p {
        width: 100%;
        margin-bottom: 0;
        margin-top: 6px;
        float: left;
        color: #7f949d;
    }
}
</style>
  